import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { tokenStore } from '@/auth/token';
import { APP_ROUTES } from '@/const/routes';

const LoginPage = lazy(() =>
  import('@/features/auth/login/LoginPage').then((m) => ({ default: m.LoginPage })),
);

export const Route = createFileRoute('/login-user')({
  beforeLoad: () => {
    if (tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.app.index });
    }
  },
  component: () => (
    <Suspense>
      <LoginPage />
    </Suspense>
  ),
});
